<template>
    <div class="tabs">
        <div class="tabs__list">
            <MyTextUnderlineBtn 
                v-for="item in tabs"
                :key="item.keyword"
                :labelText="item.title"
                :active="isActiveTab(item.keyword)"
                @click="$emit('set-tab', item.keyword)"
            />
        </div>
    </div>
</template>

<script>
import { TabItem } from './../../types' 
import VueTypes, { nullable } from 'vue-types'

export default {
    name: 'Tabs',
    props: {
        activeTab: VueTypes.oneOfType([String, nullable]),
        tabs: VueTypes.arrayOf(TabItem).def([]),
    },
    components: {
        MyTextUnderlineBtn: () => import('@/themes/novaporta/components/ui/MyTextUnderlineBtn')
    },
    methods: {
        isActiveTab(keyword) {
            return this.activeTab === keyword ? true : false
        }
    }
}
</script>

<style lang="scss">
@import '~/themes/novaporta/assets/styles/utils.scss';
@import './styles.scss';
</style>
